import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Quote, Star, BadgeCheck } from 'lucide-react';
const testimonials = [{
  name: 'Marta G.',
  age: '38 años',
  headline: 'Ligereza inmediata',
  quote: 'En 10 días dejé de sentirme hinchada por las tardes. Es la primera vez que algo me funciona de verdad.',
  initial: 'M'
}, {
  name: 'Lucía R.',
  age: '42 años',
  headline: 'Energía renovada',
  quote: 'He recuperado la energía que tenía a los 30. Ya no necesito una siesta para sobrevivir al día.',
  initial: 'L'
}, {
  name: 'Sara P.',
  age: '35 años',
  headline: 'Por fin funciona',
  quote: 'Después de años probando dietas, esto es lo único que tiene sentido. Por fin entiendo a mi cuerpo.',
  initial: 'S'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function Testimonials() {
  return <section className="py-24 md:py-32 bg-sage" data-id="element-181">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-182">
        <div className="text-center mb-16 md:mb-20" data-id="element-183">
          <span className="text-forest/60 font-semibold tracking-[0.25em] text-xs uppercase mb-4 block" data-id="element-184">
            Resultados Reales
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight text-forest leading-[1.1] max-w-3xl mx-auto" data-id="element-185">
            No es magia, es microbiota:{' '}
            <span className="text-forest/70" data-id="element-186">
              +2.400 mujeres han recuperado su ligereza
            </span>
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10" data-id="element-187">
          {testimonials.map((t, i) => <motion.figure key={i} variants={itemVariants} className="bg-white rounded-3xl p-8 md:p-10 shadow-sm border border-sage-dark/30 flex flex-col" data-id="element-188">
              <Quote className="w-7 h-7 text-forest/20 mb-4" strokeWidth={2} data-id="element-189" />

              {/* Benefit headline */}
              <h3 className="text-lg md:text-xl font-bold tracking-tight text-forest mb-3" data-id="element-190">
                {t.headline}
              </h3>

              <blockquote className="text-base text-forest/80 leading-relaxed font-medium mb-6 flex-grow" data-id="element-191">
                "{t.quote}"
              </blockquote>

              <div className="flex items-center gap-1 mb-5" data-id="element-192">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-forest text-forest" data-id="element-193" />)}
              </div>

              <figcaption className="flex items-center gap-3 pt-5 border-t border-sage" data-id="element-194">
                {/* Photo placeholder — circular */}
                <div className="w-12 h-12 rounded-full bg-sage flex items-center justify-center text-forest font-bold text-lg shrink-0 border border-sage-dark/40" data-id="element-195">
                  {t.initial}
                </div>
                <div className="min-w-0 flex-1" data-id="element-196">
                  <div className="text-sm font-bold text-forest tracking-tight" data-id="element-197">
                    {t.name}
                  </div>
                  <div className="flex items-center gap-1.5 mt-1" data-id="element-198">
                    <span className="text-xs text-forest/55 font-medium" data-id="element-199">
                      {t.age}
                    </span>
                    <span className="text-forest/20" data-id="element-200">·</span>
                    <span className="inline-flex items-center gap-1 bg-sage text-forest text-[10px] font-bold tracking-tight px-1.5 py-0.5 rounded" data-id="element-201">
                      <BadgeCheck className="w-3 h-3" strokeWidth={2.5} data-id="element-202" />
                      <span data-id="element-203">Compradora Verificada</span>
                    </span>
                  </div>
                </div>
              </figcaption>
            </motion.figure>)}
        </motion.div>
      </div>
    </section>;
}